import { notificationComponentsRegistry } from "../constants/notificationRegistry.registry"

export const getNotificationEntity = (entity, props) => {
  return notificationComponentsRegistry[entity].entity(props)
}
